var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.75H2C1.04 21.75 0.25 20.96 0.25 20V7C0.25 2.58 2.58 0.25 7 0.25H15C19.42 0.25 21.75 2.58 21.75 7V15C21.75 19.42 19.42 21.75 15 21.75ZM7 1.75C3.42 1.75 1.75 3.42 1.75 7V20C1.75 20.14 1.86 20.25 2 20.25H15C18.58 20.25 20.25 18.58 20.25 15V7C20.25 3.42 18.58 1.75 15 1.75H7Z",
    fill: "#8B8699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.25H6C5.59 9.25 5.25 8.91 5.25 8.5C5.25 8.09 5.59 7.75 6 7.75H16C16.41 7.75 16.75 8.09 16.75 8.5C16.75 8.91 16.41 9.25 16 9.25Z",
    fill: "#8B8699"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.25H6C5.59 14.25 5.25 13.91 5.25 13.5C5.25 13.09 5.59 12.75 6 12.75H13C13.41 12.75 13.75 13.09 13.75 13.5C13.75 13.91 13.41 14.25 13 14.25Z",
    fill: "#8B8699"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon2);
export default __webpack_public_path__ + "static/media/message-icon-2.0131d4e6.svg";
export { ForwardRef as ReactComponent };